












































































import {Vue, Component, Prop} from "vue-property-decorator";
import { LoraParser, IconList } from '@/types/core';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { Instance } from 'tippy.js';
import { CoreClient, curCoreClient } from '@/services/CoreClient';
import { FilterUtil } from '@/util/FilterUtil';
import { curPref, Preferences } from '@/services/Preferences';

@Component({
  components: {
    Loading,
    VueError,
    SectionHeader
  }
})
export default class LoraParserTest extends Vue {

  httpLoadBusy = false;
  httpTestBusy = false;
  errorMsg:string = '';

  testTippy?:Instance;
  testBusy = false;
  testOutput = '';

  loraPort = curPref.retrieve('v3-lora-parsers-test-last-lora-port', 1);
  hexPayload = curPref.retrieve('v3-lora-parsers-test-last-hex-payload', '');

  loraParser:LoraParser = {} as LoraParser;
    
  private coreClient:CoreClient = curCoreClient;
  private filterUtil:FilterUtil = new FilterUtil();

  iconList:IconList[] = [
    {name:'arrow-left', title:'back to parser list', event:'parser-list', alert: false},
    {name:'edit', title: 'edit parser', event:'edit' },
    {name:'trash-alt', title: this.canDelete ? 'delete parser' : 'unable to delete parser with devices associated to it', event:'delete', alert:true, disabled: !this.canDelete}
  ];
  
  mounted() {
    this.loadParser();
  }

  async loadParser() {
    this.httpLoadBusy = true;

    const loraParserReply = await this.coreClient.getLoraParser({loraParserId: this.$route.params.loraParserId});
    
    this.httpLoadBusy = false;

    if(loraParserReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(loraParserReply.errorMsg)
      return this.errorMsg = `Unable to retrieve parser ${this.$route.params.loraParserId}: ${loraParserReply.errorMsg}`;

    this.loraParser = loraParserReply.loraParser!;
  }

  async testParser(){

    this.httpTestBusy = true;

    const strippedHex = this.hexPayload.replace(/ /g,"")

    // we store these values as preferences
    curPref.store('v3-lora-parsers-test-last-lora-port', this.loraPort);
    curPref.store('v3-lora-parsers-test-last-hex-payload', this.hexPayload);

    const testReply = await this.coreClient.testLoraParser({
      loraParserId: this.$route.params.loraParserId,
      hexPayload: strippedHex,
      loraPort: this.loraPort
    });

    this.httpTestBusy = false;
    
    if(testReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(testReply.errorMsg)
      return this.errorMsg = `code test failed: ${testReply.errorMsg}`;
    
    const parsePayloadReply = testReply.parsePayloadReply!;

    if(parsePayloadReply.errorMsg){
      this.testOutput = "ERROR:" + parsePayloadReply.errorMsg;
      return;
    }

    const execResult = parsePayloadReply.executionResult!;

    let output = `**Execution time: ${execResult.durationMs} ms**\n\n`;

    if(execResult.consoleList && execResult.consoleList.length > 0) {
      output += "**Console Log**\n"
      output += execResult.consoleList.map(item => `  ${item}`).join("\n\t") + "\n\n"
    }
    
    if(execResult.readingList && execResult.readingList.length > 0) {
      output += "**Reading list**\n"
      output += JSON.stringify(execResult.readingList, null, 2);
    }

    if(execResult.readingList && execResult.readingList.length === 0) {
      output += "**Reading list** <empty>\n\n"
    }

    this.testOutput = output;
  }

  get canTest(){
    return !this.httpLoadBusy && !this.httpTestBusy;
  }

  get pageReady() {
    return !this.httpLoadBusy && this.loraParser && this.loraParser.loraParserId;
  }

  get canCancel() {
    return !this.httpLoadBusy && !this.httpTestBusy;
  }

  get canDelete() {
    if(!this.loraParser || !this.loraParser.loraParserId)
      return false;

    return this.loraParser.deviceNum === 0;
  }

  navbarClickHandler(section:'parser-list'|'edit'|'delete') {

    switch(section) {
      case 'parser-list':
        return this.$router.push({name:'lora-parser-list'});
      case 'edit':
        return this.$router.push({name:'lora-parser-edit', params:{loraParserId: this.loraParser.loraParserId}});
      case 'delete':
        return this.$router.push({name:'lora-parser-delete', params:{loraParserId: this.loraParser.loraParserId}});
    }
  }

  cancel() {
    return this.navbarClickHandler('parser-list');
  }
    
}
